import React, { lazy } from 'react';
const BONUSES = [{
  title: 'Checklist diario del sueño',
  desc: 'Para saber exactamente qué hacer cada día',
  img: 'https://cdn.magicpatterns.com/uploads/pQ2JMfaFq5AkXRhWKY8jJ1/mockup_final_BONO_1_Dormir_mejor_desde_el_amor.png'
}, {
  title: 'Guía por edad (0 a 24 meses)',
  desc: 'Adaptado a cada etapa',
  img: 'https://cdn.magicpatterns.com/uploads/2xPTgY2AjTo9ZyTDXwbu9e/mockup_final_BONO_2_Dormir_mejor_desde_el_amor.png'
}, {
  title: 'Plan de emergencia',
  desc: 'Para noches difíciles, regresiones o enfermedades',
  img: 'https://cdn.magicpatterns.com/uploads/j98XPreuFsGejBKiCgJSNo/mockup_final_BONO_3_Dormir_mejor_desde_el_amor.png'
}];
export function Bonuses() {
  return <section className="py-10 px-4 bg-gradient-to-b from-white to-yellow-50" data-id="element-11">
      <div className="max-w-6xl mx-auto" data-id="element-12">
        <div className="text-center mb-8" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-2" data-id="element-14">
            🎁 BONOS ESPECIALES (SOLO HOY)
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-15">
          {BONUSES.map((bonus, i) => <div key={i} className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100 flex flex-col" data-id="element-16">
              <div className="p-3 bg-gray-50 flex justify-center items-center" style={{
            height: '220px'
          }} data-id="element-17">
                <img src={bonus.img} alt={bonus.title} width={200} height={200} loading="lazy" decoding="async" className="max-w-full max-h-full object-contain" data-id="element-18" />
              </div>
              <div className="p-4 flex-1 flex flex-col text-center" data-id="element-19">
                <h3 className="text-lg font-bold text-gray-900 mb-1 flex items-center justify-center gap-2" data-id="element-20">
                  <span className="text-green-500" data-id="element-21">✔</span> {bonus.title}
                </h3>
                <p className="text-gray-600 font-medium text-sm" data-id="element-22">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-23">
          <p className="text-xl font-bold text-blue-900 bg-blue-100 inline-block px-6 py-3 rounded-xl" data-id="element-24">
            👉 Todo incluido sin costo adicional
          </p>
        </div>
      </div>
    </section>;
}